var en_IE = {};
module['exports'] = en_IE;
en_IE.title = "Ireland (English)";
en_IE.address = require("./address");
en_IE.internet = require("./internet");
en_IE.phone_number = require("./phone_number");
en_IE.cell_phone = require("./cell_phone");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_IE/index.js
// module id = 1025
// module chunks = 0